import styled from 'styled-components'

export const ContainerRequests = styled.div`
  margin-top: 48px;
`

export const Accordion = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const AccordionItem = styled.div`
  background: #ffffff;
  border: 1px solid #e6eef5;
  border-radius: 6px;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  overflow: hidden;
`

export const AccordionHeader = styled.button`
  width: 100%;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  border: none;
  cursor: pointer;
`

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  h3 {
    margin: 0;
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    font-size: 16px;
    color: #101828;
  }
`

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  color: ${({ variant }) => (variant === 'success' ? '#155724' : variant === 'warning' ? '#856404' : '#0c5460')};
  background: ${({ variant }) => (variant === 'success' ? '#d4edda' : variant === 'warning' ? '#fff3cd' : '#cce5ff')};
`

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  .action-link {
    color: #006eab;
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 14px;
  }
`

export const Chevron = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-right: 2px solid #006eab;
  border-bottom: 2px solid #006eab;
  transform: ${({ $open }) => ($open ? 'rotate(-135deg)' : 'rotate(45deg)')};
  transition: transform 0.15s ease-in-out;
  margin-left: 4px;
`

export const AccordionContent = styled.div`
  padding: ${({ $open }) => ($open ? '16px' : '0 16px')};
  max-height: ${({ $open }) => ($open ? '2000px' : '0')};
  overflow: hidden;
  transition: max-height 0.2s ease, padding 0.2s ease;
  }
`
